import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Modal from "react-modal";
import { destroy } from "redux-form";

import { resetGivingForm, GIVING_FORM_PAGINATION_SCOPE } from "data/giving-form";

import { reset as resetPagination } from "data/pagination";

import { getEntity } from "data/entity";

import { nextPage, previousPage, getRoute } from "data/giving-form/routes";

import { getSelectedAllocations } from "data/giving-form/allocation-selection";

import SuccessMessage from "../../../../lib/components/SuccessMessage";

import SelectDonationInfo from "../routes/SelectDonationInfo";
import Form from "../routes/Form";
import ThankYou from "../routes/ThankYou";

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    overflowX: "hidden",
    overflowY: "auto",
    zIndex: 2000,
  },
  content: {
    position: "relative",
    height: "100%",
    top: "initial",
    bottom: "initial",
    left: "initial",
    right: "initial",
    padding: 0,
    border: "initial",
    background: "initial",
    WebkitOverflowScrolling: "touch",
    outline: "none",
  },
};

class GivingModal extends React.Component {
  static propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  handleNextPage = () => {
    const { currentRoute, nextPage, selectedAllocations } = this.props;

    if (currentRoute == "selection") {
      if (typeof window.EventAnalyticsService != "undefined") {
        const donationAmounts = [];
        selectedAllocations.forEach((allocation) => {
          donationAmounts.push(allocation.get("amount"));
        });
        window.EventAnalyticsService.addEvent({
          name: "GIVING FORM - FINISH ALLOCATIONS",
          giving_form_version: "React",
          number_of_allocations: selectedAllocations.count(),
          donation_amounts: donationAmounts,
        });
      }
    }

    nextPage();
  };

  handlePreviousPage = () => {
    const { previousPage } = this.props;

    previousPage();
  };

  reset() {
    const { destroy, resetGivingForm, resetPagination, onClose } = this.props;

    onClose();
    destroy("donation");
    resetGivingForm();
  }

  closeModal = () => {
    this.reset();
  };

  componentWillUnmount() {
    this.reset();
  }

  renderContent() {
    const {
      currentRoute,
      dontPreselectCampaign,
      shellCampaign,
      entity,
      availableLocales,
      selectedLocale,
      handleLanguageChange,
      currencyCode,
    } = this.props;

    switch (currentRoute) {
      case "selection": {
        return (
          <SelectDonationInfo
            onCloseModal={this.closeModal}
            availableLocales={availableLocales}
            selectedLocale={selectedLocale}
            handleLanguageChange={handleLanguageChange}
            nextPage={this.handleNextPage}
            dontPreselectCampaign={dontPreselectCampaign}
            shellCampaign={shellCampaign}
            hasConfirmationStep={entity.get("has_giving_form_confirmation_step")}
          />
        );
      }

      case "donate": {
        return (
          <Form
            data-testid="t-giving-form--GivingM-Form"
            currencyCode={currencyCode}
            availableLocales={availableLocales}
            selectedLocale={selectedLocale}
            handleLanguageChange={handleLanguageChange}
            previousPage={this.handlePreviousPage}
            onCloseModal={this.closeModal}
            nextPage={this.handleNextPage}
            hasConfirmationStep={entity.get("has_giving_form_confirmation_step")}
          />
        );
      }

      case "thank-you": {
        return (
          <ThankYou
            currencyCode={currencyCode}
            availableLocales={availableLocales}
            selectedLocale={selectedLocale}
            handleLanguageChange={handleLanguageChange}
            onCloseModal={this.closeModal}
            nextPage={this.handleNextPage}
          />
        );
      }

      case "success": {
        return (
          <SuccessMessage
            availableLocales={availableLocales}
            selectedLocale={selectedLocale}
            handleLanguageChange={handleLanguageChange}
            successMessageTitle={"Thank you!"}
            successMessage={"You’ve successfully made a gift"}
            afterClose={this.closeModal}
            isOpen={true}
          />
        );
      }

      default: {
        return null;
      }
    }
  }

  render() {
    const { isModalOpen } = this.props;

    if (!isModalOpen) {
      return null;
    }

    return (
      <Modal
        contentLabel="Donation Form"
        closeTimeoutMS={150}
        isOpen={isModalOpen}
        onRequetClose={this.closeModal}
        htmlOpenClassName="ReactModal__Html--open"
        style={customStyles}>
        {this.renderContent()}
      </Modal>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    currentRoute: getRoute(state),
    entity: getEntity(state),
    selectedAllocations: getSelectedAllocations(state),
  };
};

const mapActionCreators = {
  destroy,
  previousPage,
  nextPage,
  resetGivingForm,
  resetPagination() {
    return resetPagination({ scope: GIVING_FORM_PAGINATION_SCOPE });
  },
};
export default connect(mapStatetoProps, mapActionCreators)(GivingModal);
